import React, { FC } from 'react'

import { Txt } from 'src/components/atoms'
import { CheckboxWithTxt } from 'src/components/molecules'

type Props = {
  selectedStatusNames: string[]
  updateStatusNames: (statuses: string[]) => void
  hasArchived?: boolean
  className?: string
}

export const ProjectSearchStatus: FC<Props> = ({
  selectedStatusNames,
  updateStatusNames,
  hasArchived,
  className,
}) => {
  const handleOnClick = (selectedStatus: string) => {
    if (selectedStatusNames.includes(selectedStatus)) {
      updateStatusNames(selectedStatusNames.filter(status => status !== selectedStatus))
    } else {
      updateStatusNames([...selectedStatusNames, selectedStatus])
    }
  }

  return (
    <div className={className}>
      <Txt sizeType="s" className="tw-text-standardText-secondary">
        ステータス
      </Txt>
      <div className="tw-flex tw-flex-wrap tw-mt-s-2 tw-gap-s0">
        <CheckboxWithTxt
          text="停止中"
          checked={selectedStatusNames.includes('stopped')}
          onClick={() => handleOnClick('stopped')}
        />
        {hasArchived && (
          <CheckboxWithTxt
            text="アーカイブ"
            checked={selectedStatusNames.includes('archived')}
            onClick={() => handleOnClick('archived')}
          />
        )}
        <CheckboxWithTxt
          text="準備中"
          checked={selectedStatusNames.includes('preparing')}
          onClick={() => handleOnClick('preparing')}
        />
        <CheckboxWithTxt
          text="稼働中"
          checked={selectedStatusNames.includes('active')}
          onClick={() => handleOnClick('active')}
        />
      </div>
    </div>
  )
}
